(function () {
  var root = document.querySelector('[data-eb-demo]');
  if (!root) return;
  var form = root.querySelector('[data-eb-form]');
  var out = root.querySelector('[data-eb-out]');
  var copyBtn = root.querySelector('[data-eb-copy]');
  var status = root.querySelector('[data-eb-status]');
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));

  // kind: 0 texto, 1 dato rellenado, 2 hueco vacío
  var JOBS = {
    inmobiliarias: {
      fields: [
        { id: 'operacion', label: 'Operación', type: 'select', opts: ['venta', 'alquiler'], half: 1, ph: 'venta/alquiler' },
        { id: 'tipo', label: 'Tipo de inmueble', type: 'select', opts: ['piso', 'casa', 'local', 'ático'], half: 1, ph: 'tipo' },
        { id: 'zona', label: 'Zona', type: 'text', value: 'Centro, ciudad mediana', half: 1, ph: 'barrio y ciudad' },
        { id: 'superficie', label: 'Superficie (m²)', type: 'number', value: '85', half: 1, ph: 'm² construidos' },
        { id: 'extras', label: 'Extras comprobados', type: 'text', value: 'ascensor', ph: 'terraza, ascensor...' }
      ],
      build: function (v) {
        var sup = v('superficie');
        return [
          [['Actúa como redactor inmobiliario. Escribe la descripción de un anuncio de ', 0], v('operacion'), [' en español de España, de 120 a 150 palabras, con tono cercano y profesional.', 0]],
          null,
          [['Datos reales (no añadas ninguno más):', 0]],
          [['• Tipo de inmueble: ', 0], v('tipo')],
          [['• Zona: ', 0], v('zona')],
          [['• Superficie: ', 0], sup[1] === 2 ? sup : [sup[0] + ' m²', 1]],
          [['• Extras comprobados: ', 0], v('extras')],
          null,
          [['Estructura: un gancho de una frase, tres puntos fuertes, el entorno y un cierre que invite a visitar. No uses superlativos que no pueda demostrar.', 0]]
        ];
      }
    },
    gestorias: {
      fields: [
        { id: 'tramite', label: 'Trámite', type: 'select', opts: ['cierre del trimestre', 'alta de autónomo', 'declaración de la renta', 'alta de un trabajador'], ph: 'trámite' },
        { id: 'docs', label: 'Documentos que faltan', type: 'text', value: 'facturas y extractos del trimestre', ph: 'lista de documentos' },
        { id: 'fecha', label: 'Fecha límite interna', type: 'text', value: 'viernes 15', half: 1, ph: 'fecha' },
        { id: 'tono', label: 'Tono', type: 'select', opts: ['cercano', 'formal'], half: 1, ph: 'tono' }
      ],
      build: function (v) {
        return [
          [['Redacta un correo ', 0], v('tono'), [' y claro para pedir a un cliente la documentación de este trámite:', 0]],
          [['• Trámite: ', 0], v('tramite')],
          [['• Documentos: ', 0], v('docs')],
          [['• Fecha límite interna: ', 0], v('fecha')],
          null,
          [['No incluyas nombres ni datos fiscales del cliente. Máximo 120 palabras. Termina ofreciendo ayuda si no sabe dónde conseguir algún documento.', 0]]
        ];
      }
    },
    clinicas: {
      fields: [
        { id: 'mensaje', label: 'Mensaje', type: 'select', opts: ['confirmar una cita', 'recordar una revisión', 'cambiar una cita'], ph: 'tipo de mensaje' },
        { id: 'fecha', label: 'Fecha', type: 'text', value: 'martes 14', half: 1, ph: 'fecha' },
        { id: 'hora', label: 'Hora', type: 'text', value: '17:30', half: 1, ph: 'hora' },
        { id: 'tel', label: 'Teléfono de la clínica', type: 'text', value: '', ph: 'teléfono' }
      ],
      build: function (v) {
        return [
          [['Redacta un mensaje breve y amable para ', 0], v('mensaje'), [' en una clínica dental.', 0]],
          [['• Fecha: ', 0], v('fecha')],
          [['• Hora: ', 0], v('hora')],
          [['• Teléfono para cambiarla: ', 0], v('tel')],
          null,
          [['No menciones el motivo de la visita ni ningún dato de salud. Pide confirmar con una respuesta corta. Máximo 40 palabras.', 0]]
        ];
      }
    },
    abogados: {
      fields: [
        { id: 'escrito', label: 'Documento', type: 'select', opts: ['una demanda', 'una contestación a la demanda', 'un contrato de arrendamiento', 'una carta de reclamación'], ph: 'documento' },
        { id: 'ambito', label: 'Ámbito', type: 'select', opts: ['civil', 'laboral', 'mercantil'], half: 1, ph: 'ámbito' },
        { id: 'resumen', label: 'Asunto (sin nombres reales)', type: 'text', value: 'cobro de una factura impagada', ph: 'resumen del asunto' }
      ],
      build: function (v) {
        return [
          [['Prepara solo el esquema vacío de ', 0], v('escrito'), [' del ámbito ', 0], v('ambito'), [', con sus apartados habituales y una nota breve de qué va en cada uno.', 0]],
          [['• Asunto: ', 0], v('resumen')],
          null,
          [['No redactes fundamentos jurídicos ni cites normas o sentencias: eso lo aporto yo desde fuentes oficiales. Marca entre corchetes lo que falte.', 0]]
        ];
      }
    }
  };

  var state = {}, current = 'inmobiliarias';

  function getVal(job, f) {
    var s = state[job] || (state[job] = {});
    return Object.prototype.hasOwnProperty.call(s, f.id) ? s[f.id] : (f.value !== undefined ? f.value : (f.opts ? f.opts[0] : ''));
  }
  function vfor(job) {
    var J = JOBS[job];
    return function (id) {
      var f = J.fields.filter(function (x) { return x.id === id; })[0];
      var val = (getVal(job, f) || '').trim();
      return val ? [val, 1] : ['[' + f.ph + ']', 2];
    };
  }

  function buildForm() {
    form.textContent = '';
    JOBS[current].fields.forEach(function (f) {
      var wrap = document.createElement('div');
      wrap.className = 'eb-field' + (f.half ? ' eb-field--half' : '');
      var id = 'eb-f-' + current + '-' + f.id;
      var lab = document.createElement('label');
      lab.className = 'eb-label'; lab.setAttribute('for', id); lab.textContent = f.label;
      var el;
      if (f.type === 'select') {
        el = document.createElement('select');
        f.opts.forEach(function (o) {
          var op = document.createElement('option'); op.textContent = o; el.appendChild(op);
        });
        el.value = getVal(current, f);
      } else {
        el = document.createElement('input');
        el.type = f.type; el.value = getVal(current, f); el.maxLength = 90;
        if (f.type === 'number') { el.inputMode = 'numeric'; el.min = 10; el.max = 2000; }
        if (f.type === 'text') el.placeholder = f.ph;
      }
      el.className = 'eb-input'; el.id = id; el.name = f.id;
      wrap.appendChild(lab); wrap.appendChild(el); form.appendChild(wrap);
    });
  }

  function render(animate) {
    var L = JOBS[current].build(vfor(current));
    out.textContent = '';
    if (animate) { out.setAttribute('data-anim', ''); clearTimeout(render.t); render.t = setTimeout(function () { out.removeAttribute('data-anim'); }, 1400); }
    L.forEach(function (parts, i) {
      var p = document.createElement('p');
      p.className = 'eb-out__line';
      p.style.setProperty('--i', i);
      if (!parts) { p.innerHTML = '&nbsp;'; out.appendChild(p); return; }
      parts.forEach(function (part) {
        if (part[1] === 0) { p.appendChild(document.createTextNode(part[0])); return; }
        var m = document.createElement('mark');
        if (part[1] === 2) m.className = 'is-empty';
        m.textContent = part[0];
        p.appendChild(m);
      });
      out.appendChild(p);
    });
  }

  function toPlain() {
    return JOBS[current].build(vfor(current)).map(function (parts) {
      return parts ? parts.map(function (x) { return x[0]; }).join('') : '';
    }).join('\n');
  }

  function say(msg) {
    if (!status) return;
    status.textContent = msg;
    clearTimeout(say.t);
    say.t = setTimeout(function () { status.textContent = ''; }, 2600);
  }

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', '');
    ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    return ok;
  }

  function select(job, focus) {
    current = job;
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-job') === job;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on) { out.setAttribute('aria-labelledby', t.id); if (focus) t.focus(); }
    });
    buildForm();
    render(true);
  }

  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { select(t.getAttribute('data-job'), false); });
    t.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      select(tabs[(i + d + tabs.length) % tabs.length].getAttribute('data-job'), true);
    });
  });

  if (copyBtn) copyBtn.addEventListener('click', function () {
    var text = toPlain();
    var fail = 'No se pudo copiar. Selecciona el texto a mano.';
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () { say('Instrucción copiada'); }, function () {
        say(legacyCopy(text) ? 'Instrucción copiada' : fail);
      });
    } else {
      say(legacyCopy(text) ? 'Instrucción copiada' : fail);
    }
  });

  function onInput(e) {
    var el = e.target, name = el.name;
    if (!name) return;
    (state[current] || (state[current] = {}))[name] = el.value;
    render(false);
  }
  form.addEventListener('input', onInput);
  form.addEventListener('change', onInput);
  form.addEventListener('submit', function (e) { e.preventDefault(); });
  select('inmobiliarias', false);
})();
